import {
  ICpOption,
  IDynamicAttributeEnhanced,
  ICPAttributesCollection,
  ICPAttributeFullData,
} from "models/Assets/IDynamicAttributes";

export const filterDynamicAttributesByFieldName = (
  dynamicAttributeEnhancedAssets: IDynamicAttributeEnhanced[],
  attr: IDynamicAttributeEnhanced | string
): IDynamicAttributeEnhanced => {
  if (!dynamicAttributeEnhancedAssets || dynamicAttributeEnhancedAssets.length === 0) return null;
  if (typeof attr === "string") {
    const fieldName = attr;
    [attr] = dynamicAttributeEnhancedAssets.filter(
      (a) => a.fieldName === fieldName
    );
    if (!attr) {
      return null;
    }
  }
  return attr;
};

export const filterCPOptionByOptionIdAndFieldName = (
  dynamicAttributeEnhancedAssets: IDynamicAttributeEnhanced[],
  attr: IDynamicAttributeEnhanced | string,
  optionId: number | string
): ICpOption | null => {
  if (!dynamicAttributeEnhancedAssets) return null;
  attr = filterDynamicAttributesByFieldName(
    dynamicAttributeEnhancedAssets,
    attr
  );
  const [option=null] = (attr?.options || []).filter((o) => o.id == optionId);
  return option;
};

export const filterDynamicAttributesBySubCatId = (
  dynamicAttrs: ICPAttributesCollection,
  subCategoryId: number | string
): IDynamicAttributeEnhanced[] => {
  return dynamicAttrs[subCategoryId];
};

export const toLiteCPAttribute = (
  lang: "ar" | "en" | string,
  attr: ICPAttributeFullData,
  parentOptionIds?: (number | string)[]
): IDynamicAttributeEnhanced => {
  const attrCopy = { ...attr };
  if (attrCopy.field.isChild) {
    if (Array.isArray(parentOptionIds) && parentOptionIds.length === 1) {
      const [parentOptionId, secondParentOptionId] = parentOptionIds;
      if (parentOptionId && !secondParentOptionId) {
        attrCopy.options = [
          ...(attrCopy.optionsByParents[parentOptionId] || []),
        ];
      }
    }
    delete attrCopy.optionsByParents;
  }

  return attrCopy;
};
